import type { ComponentProps } from 'react';

import type { PageGrid } from 'corgi/common/components/PageGrid';

export const CONTENT_MAX_WIDTH = '1472px';

export const STICKY_GRID_STYLES: ComponentProps<typeof PageGrid> = {
  position: 'sticky',
  top: 0,
  zIndex: 2,
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '100%',
};

export const getStickyGridStyles = (isShopInShop: boolean) =>
  isShopInShop ? { ...STICKY_GRID_STYLES, top: [0, 76, null, 92] } : STICKY_GRID_STYLES;

export const STICKY_FILTERED_STYLES: ComponentProps<typeof PageGrid> = {
  position: 'sticky',
  top: [76, 76, 76, 92],
  zIndex: 1,
  backgroundColor: 'sys.neutral.background.default',
  maxWidth: '100%',
};

export const withShopInShopNavStyles = (withShopInShop: boolean) =>
  withShopInShop ? { top: [76, null, null, 92] } : { top: 0 };
